import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Skeleton } from "../../skeleton/Skeleton";
export const OptionLoading = () => (_jsxs(LoaderWrapper, { children: [_jsx(LoaderItem, { "$size": "small" }), _jsx(LoaderItem, { "$size": "small" }), _jsx(LoaderItem, { "$size": "small" })] }));
const LoaderWrapper = styled.div `
  padding: ${({ theme: { spacing: { sp8 }, }, }) => `${sp8}`};

  & > :not(:first-child) {
    margin-top: ${(p) => p.theme.spacing.sp16};
  }
`;
const LoaderItem = styled(Skeleton) `
  margin: ${(p) => p.theme.spacing.sp8} 0;
`;
